import React, { useEffect, useState } from 'react';
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Modal, Spin, Radio } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { setLocationData, uploadImageRequest, uploadImageResponse, deleteImageResponse, resetLocationData, updateModal, fetchImageRequest } from '../../../store/actions/location';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@vds/icons';
import { handleClosePopup, handleSubmit } from './locationUtils';
import { updateLocation, createLocation } from "../../../global/utility/Utils";
import ToastNotification from "../../../global/components/ToastNotification";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";
import { DropDown } from '../wrapperComponents/DropDown';
import {Input} from "@vds/inputs"
import FloorImageComponent from './floorImageComponent';
import { ErrorMessage } from '../../../global/components/ValidationIcon';
import { ZoneFormContent } from './ZoneFormContent';
import { useZoneValidation } from './customHooks/useZoneValidation';
import { useUploadFloorFile } from './customHooks/useUploadFloorFile';
import { select } from 'redux-saga/effects';

const LocationOptPopup = ({ visible }) => {
  const dispatch = useDispatch();
  const location_data = useSelector((state) => state.location.location_data);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [errors, setErrors] = useState({ initial : true });
  let disableNextButton = false;
  if(location_data?.selectedFloorDeleted){
    disableNextButton = false;
  }else{
    disableNextButton = (location_data?.action_type == 'edit' && (!location_data?.selectedFloorKey && !location_data?.editNewFloorUpdated))
  }
  const current_modal = useSelector(state => state.location?.current_modal);
  const apiLoading = useSelector((state) => state.location.isApiLoading);
  const [firstTimeAlert, setFirstTimeAlert] = useState(true);
  const { validateZoneFields } = useZoneValidation();
  const uploadFile = useUploadFloorFile();
  const oldLocData = React.useRef(null);
    useEffect(() => {
        const old_loc_data = JSON.parse(JSON.stringify(location_data));
        if (location_data?.action_type === 'edit' && (current_modal === 'NewFloor' || current_modal === 'AddFloor')) {
            oldLocData.current = {...old_loc_data, addNewZoneButtonClicked: false, selectedFloorKey: null};
        }
    }, []);

    const oldDataAlert = () => {
        setNotificationProps({
            type: 'info',
            message: 'Are you sure you want to go back?',
            description: 'Please save the changes or otherwise data will be lost.',
            duration: 3,
            style: { marginTop: '5vh', className: 'custom-class-notification-inv-loc' },
        });
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 1000);
    }
    // if (name === "locationName") {
    //     const charLimitMessage = getCharLimitMsgIfExceeded("CATEGORY_TEXT", value);
    //     if (charLimitMessage) {
    //         tempErrors.locationName = charLimitMessage;
    //     }
    // }

useEffect(() => {
    if(location_data?.backButtonClicked){
        setTimeout(() => dispatch(setLocationData({ ...location_data, addNewZoneButtonClicked: false, selectedFloorKey: null }) ), 1);
    }
},[]);

useEffect(()=>{
    dispatch(setLocationData({ ...location_data, isUploadingImage: false }));
    dispatch(uploadImageResponse({ data: null, success: false }));
    dispatch(setLocationData({ ...location_data, isDeleteImage: false }));
    dispatch(deleteImageResponse({ data: null, success: false }));
},[])

useEffect(() => {
    const imageRequests = Object.values(location_data?.floors).filter((floor) => !(floor?.file instanceof Blob)).map((floor) => {
        return { imageId: floor?.floorImageId, floorKey: floor?.id };
    });
    imageRequests.length > 0 && dispatch(fetchImageRequest(imageRequests));
}, [location_data?.floors]);

const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && (droppedFile.type === "image/jpeg" || droppedFile.type === "image/png") && droppedFile.size <= 10 * 1024 * 1024) {
        uploadFile(droppedFile);
    }
};

const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

const handleBrowse = (e, floorImageId, floorKey, isEditFloorMap=false) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png") && selectedFile.size <= 10 * 1024 * 1024) {
        uploadFile(selectedFile, floorImageId, floorKey, isEditFloorMap);
    }
    e.target.value = null; // reset input so same file can be selected again
};

const handleZoneSubmit = () => {
    const isValid = validateZoneFields(location_data?.selectedFloorKey, location_data?.newZones?.[location_data?.selectedFloorKey]?.zone_id_selected);
    if (!isValid) return;
    const bool = (location_data?.createtype == 'NewZone' || location_data?.createtype == 'NewFloor' || location_data?.createtype == 'AddFloor' || location_data?.action_type == 'edit') && !location_data?.cloneAction;
    const submitFn = bool ? updateLocation : createLocation;
    handleSubmit(location_data, dispatch, resetLocationData, submitFn, setNotificationProps, setShowNotification);
}

    const floorMapList = (floor, floorKey) => {

        return (
            <>
                {
                    (location_data?.action_type != 'edit' || (location_data?.action_type == 'edit' && !location_data?.selectedFloorKey)) &&
                    <div className="mb-1">
                        <label className="input-label-user">Floor name</label>
                        <div style={{ marginBottom: '8px !important' }}>
                            <Input
                                type="text"
                                id="floorName"
                                name="floorName"
                                value={floor?.name}
                                maxLength={30}
                                required={false}
                                onChange={e => {
                                    dispatch(setLocationData({ ...location_data, floors: { ...location_data.floors, [floorKey]: { ...floor, name: e.target.value } } }));
                                }}
                                placeholder="Enter floor name"
                                error={(errors?.initial == true) ? false : (((errors?.[floorKey])?.length > 0) ? true : false)}
                                errorText={((errors?.[floorKey]?.length > 0) ? errors?.[floorKey] : '')}

                                // error={location_data?.errors?.[floorKey]?.error ? (location_data?.errors?.[floorKey]?.error == 'initial' ? false : true) : true}
                                // errorText={location_data?.errors?.[floorKey]?.errorText ? location_data?.errors?.[floorKey]?.errorText : ''}
                            />
                        </div>
                    </div>
                }
                {floor.file && (
                    <>
                        {
                            (floorKey && floor?.floorImageId) &&
                            <div style={{ marginBottom: 24, paddingTop: 16, borderRadius: 8, marginTop: 12 }}>

                                <Spin spinning={!(floor?.file instanceof Blob) && location_data?.fetchImageResponse?.[floorKey]?.success} >
                                    <FloorImageComponent floorid={floorKey} />
                                </Spin>
                            </div>
                        }
                    </>
                )}
                <>
                    <div style={{
                        position: "relative",
                        top: "-11px",
                        left: "1px",
                        color: '#6F7171',
                        fontSize: '12px',

                    }}
                        className='font12Location'
                    >

                        {
                            (current_modal == 'AddFloor' || current_modal == 'NewFloor') &&
                                location_data?.action_type == 'edit' && !location_data?.editNewFloorUpdated ?
                                'Select a zone to edit'
                                : ''
                        }
                    </div>
                </>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '9px', borderBottom: '1px solid #ccc', paddingBottom: '32px', position: 'relative', top: `${(location_data?.action_type == 'edit' ? '4px' : '-12px')}` }}>
                    <a
                        href="#"
                        className='font12Location'
                        style={{ color: '#000000' }}
                        onClick={e => {
                            e.preventDefault();
                            //handleBrowse(e, floor.floorImageId, floorKey, true);
                            const input = document.getElementById('floor-map-upload-input');
                            input.onchange = (event) => {
                                handleBrowse(event, floor.floorImageId, floorKey);
                                input.value = ''; // reset input so same file can be selected again
                                input.onchange = (event) => handleBrowse(event);
                            };
                            input.click();
                        }}
                    >
                        Change Floor Map
                    </a>
                    <a
                        href="#"
                        className='font12Location'
                        style={{ color: '#000000' }}
                        onClick={e => {
                            e.preventDefault();
                            const updatedFloors = location_data.floors;
                            delete updatedFloors[floorKey];
                            if(location_data?.selectedFloorKey){
                                dispatch(setLocationData({ ...location_data, imageIdsForDelete: [...location_data.imageIdsForDelete, floor.floorImageId], selectedFloorKey: null, selectedFloorDeleted: true }));
                            }else{
                                if(location_data?.action_type == 'edit'){
                                   dispatch(setLocationData({ ...location_data, imageIdsForDelete: [...location_data.imageIdsForDelete, floor.floorImageId], floors: { ...updatedFloors }, editNewFloorUpdatedId: '', editNewFloorUpdated: false }));
                                }else{
                                    dispatch(setLocationData({ ...location_data, imageIdsForDelete: [...location_data.imageIdsForDelete, floor.floorImageId], floors: { ...updatedFloors }, editNewFloorUpdatedId: '' }));
                                }            
                            }
                        }}
                    >
                        Delete Floor
                    </a>
                </div>
            </>
        )
    }

const validate = () => {
    const tempErrors = { ...errors };
     for(const floorKey of Object.keys(location_data?.floors)){
        const floor = location_data.floors[floorKey];
        if (!floor?.name || floor?.name?.trim() === '' || floor?.name?.length > MAX_CHAR_LIMITS.CATEGORY_TEXT || floor?.name?.length < 3 ) {
            tempErrors[floorKey] = 'Please enter floor name';
        } else{
            tempErrors[floorKey] = '';
        }
    }

    for(const keys of Object.keys(tempErrors)){
        if(keys?.startsWith('floor_') && !(keys in location_data?.floors)){
            delete tempErrors[keys];
        }
    }

    if((location_data?.createtype == 'NewFloor' || location_data?.createtype == 'AddFloor') && location_data?.action_type == 'add'){
        if(location_data?.editNewFloorUpdatedId?.length == 0 || !(location_data?.editNewFloorUpdatedId)){
            tempErrors['no_new_floors_added'] = 'Please add at least one floor';
        }else{
            tempErrors['no_new_floors_added'] = '';
        }
    }

    if(Object.keys(location_data?.floors)?.length == 0){
        tempErrors['no_floors'] = 'Please add at least one floor';
    }else{
        tempErrors['no_floors'] = '';
    }
    tempErrors['initial'] = false;
    setErrors({ ...tempErrors });
    if (Object.values(tempErrors).some((x) => x !== '' && x !== "initial" && x !== false)) {
        setNotificationProps({
            type: 'error',
            message: 'Add Floor',
            description: 'Please fix the following errors to proceed: ' + Object.values(tempErrors).filter((x) => x !== '' && x !== "initial" && x !== false).join(', '),
            duration: 1,
            style: { backgroundColor: "#f8d7da", color: "#721c24" },
        });
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 1000);
        return true;
    }else{
        return false;
    }
}

    const handleFloorMapSubmit = () => {
        if (validate()) return;
        if (location_data?.action_type?.toLowerCase() == 'add' && location_data?.createtype == 'NewFloor') {
            let location_data_temp = { ...location_data };
            if ((location_data?.createtype == 'NewFloor' || location_data?.createtype == 'AddFloor') && location_data?.addfloormap != true) {
                location_data_temp = { ...location_data, addfloormap: true };
            }
            handleSubmit(location_data_temp, dispatch, resetLocationData, updateLocation, setNotificationProps, setShowNotification);
        } else if ((location_data?.action_type == 'edit' && (location_data?.selectedFloorDeleted && (location_data?.editNewFloorUpdatedId?.length == 0 || !location_data?.editNewFloorUpdatedId)))) {
            let location_data_temp = { ...location_data };
            if ((location_data?.createtype == 'NewFloor' || location_data?.createtype == 'AddFloor') && location_data?.addfloormap != true) {
                location_data_temp = { ...location_data, addfloormap: true };
            }
            handleSubmit(location_data_temp, dispatch, resetLocationData, updateLocation, setNotificationProps, setShowNotification);
        } else {
            dispatch(updateModal({ current_modal: 'AddZone' }));
        }
    }

return (
    <div>
        <Modal
            title=""
            open={visible}
            onCancel={() => { handleClosePopup({dispatch}) }}
            footer={[
                <Grid2
                    container
                    marginTop={0}
                    marginBottom={0}
                    spacing={2}
                    columns={{ xs: 12 }}
                >
                    <Grid2 item xs={12} sm={6} md={6} lg={6}>
                        <div className="mb-0">
                            <Button
                                className="custom-button-cancel"
                                type="default"
                                onClick={() => { handleClosePopup({dispatch}) }}
                                shape="round"
                                style={{ fontWeight: "bold", width: "100%" }}
                                size={"large"}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Grid2>
                    <Grid2 item xs={12} sm={6} md={6} lg={6}>
                        <div className="mb-0">
                            <Button
                                className={`${disableNextButton ? 'edit-inventory-location-save-disabled' : 'custom-button-save'}`}
                                type="primary"
                                onClick={(e) => {if(location_data?.renderZonePopupInFloorMapPopup || (location_data?.action_type == 'edit' && !location_data?.editNewFloorUpdated && !location_data?.selectedFloorDeleted)){handleZoneSubmit()}else{handleFloorMapSubmit()}}}
                                shape="round"
                                style={{
                                    width: "100%",
                                    backgroundColor: disableNextButton ? '#D8DADA' : "black",
                                    color: "white",
                                    fontWeight: "bold",
                                }}
                                disabled = {disableNextButton}
                                size={"large"}
                            >
                                {
                                    location_data?.renderZonePopupInFloorMapPopup ? 'Save' : ( (location_data?.action_type == 'edit' && !location_data?.editNewFloorUpdated) ? 'Save' : ( location_data?.createtype == 'NewFloor' ? 'Add' : 'Next'))
                                }
                            </Button>
                        </div>
                    </Grid2>
                </Grid2>,
            ]}
            className="custom-modal-inventoryLocation"            
            width={680}
        >
            <button type="button" className="ant-modal-back" aria-label="back" onClick={() => {
                if (firstTimeAlert) {
                    oldDataAlert();
                    setFirstTimeAlert(false); return;
                }
                if (location_data?.renderZonePopupInFloorMapPopup) {
                    setTimeout(() => { dispatch(setLocationData({ ...oldLocData.current, renderZonePopupInFloorMapPopup: false, selectedFloorKey: null, backButtonClicked: true, editNewFloorUpdated: false, editNewFloorUpdatedId: null })) }, 100)
                } else {
                    dispatch(setLocationData({ ...oldLocData.current, backButtonClicked: true, selectedFloorKey: null, editNewFloorUpdated: false, editNewFloorUpdatedId: null }) );
                    dispatch(updateModal({ current_modal: 'inventory_location' }));
                }
            }}><Icon name="left-arrow" size={"small"} /></button>
            {showNotification && (
                <ToastNotification
                    type={notificationProps.type}
                    message={notificationProps.message}
                    description={notificationProps.description}
                    duration={notificationProps.duration}
                    style={notificationProps.style}
                />

            )}
            <Spin spinning={location_data?.isUploadingImage || location_data?.isDeleteImage || location_data?.isFetchingImage || apiLoading} >
                {
                    location_data?.renderZonePopupInFloorMapPopup ? <ZoneFormContent visible={location_data?.renderZonePopupInFloorMapPopup}/> :
                        <div style={{ marginBottom: "5px", marginTop: "5px" }}>
                            {location_data?.action_type == 'edit' ?
                                (<>
                                    <h2 className={"font-face-vzb page-header-location"}>
                                        Edit Location
                                    </h2></>)
                                :
                                (<><p className={"inventory-location-popup-title"}>
                                    Add Location
                                </p>
                                    <h2 className={"font-face-vzb page-header-location"}>
                                        Add Floor
                                    </h2>
                                    <p className={"inventory-location-popup-title"} style={{ marginBottom: 20 }}>
                                        Upload floor plan for better accuracy.
                                    </p></>)}
                            <Grid2
                                container
                                marginTop={1}
                                marginBottom={2}
                                spacing={1}
                                columns={{ xs: 12 }}
                            >
                                {location_data?.action_type == 'edit' ?
                                    !location_data?.selectedFloorKey && location_data?.editNewFloorUpdated ?
                                        <Grid2 item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: 24 }}>
                                            {
                                                Object.keys(location_data?.floors).length > 0 && Object.keys(location_data.floors).map((floorKey, index) => {
                                                    const floor = location_data.floors[floorKey];
                                                    if (floor?.file instanceof File) {
                                                        return floorMapList(floor, floorKey);
                                                    }
                                                })}
                                        </Grid2>
                                        :
                                        <Grid2 item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: 24 }}>
                                            <DropDown
                                                label="Floor name"
                                                value={location_data?.selectedFloorKey}
                                                name={"locationNameDropDownFloor"}
                                                customClass={'left-3px'}
                                                onChangeFn={
                                                    (value) => { dispatch(setLocationData({ ...location_data, selectedFloorKey: value })); }
                                                }
                                                placeholder={"Select a floor"}
                                                error={(errors?.initial == true) ? false : (((errors[location_data?.selectedFloorKey])?.length > 0) ? true : false)}
                                                errors={{
                                                    'locationNameDropDownFloor': ((errors[location_data?.selectedFloorKey]?.length > 0) ? errors[location_data?.selectedFloorKey] : '')
                                                }}
                                                options={Object.keys(location_data.floors).map((floorKey) => ({ label: location_data.floors[floorKey].name, value: floorKey }))}
                                            />
                                            <div className='font12Location' style={{ color: '#6F7171', marginTop: '-11px', marginLeft: '2px' }}>
                                                Select floor which you want to edit.
                                            </div>

                                            <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                                                {location_data?.floors[location_data?.selectedFloorKey] && location_data?.floors[location_data?.selectedFloorKey]?.file instanceof Blob && floorMapList(location_data.floors[location_data.selectedFloorKey], location_data.selectedFloorKey)}
                                            </Grid2>
                                        </Grid2>
                                    :
                                    (<Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                                        {
                                            (location_data?.createtype === 'NewFloor' || location_data?.createtype === 'AddFloor') ?
                                                Object.keys(location_data?.floors).length > 0 && Object.keys(location_data.floors).map((floorKey, index) => {
                                                    const floor = location_data.floors[floorKey];
                                                    return floor?.file instanceof Blob ? floorMapList(floor, floorKey) : null;
                                                })
                                                : Object.keys(location_data?.floors).length > 0 && Object.keys(location_data.floors).map((floorKey, index) => {
                                                    const floor = location_data.floors[floorKey];
                                                    return floorMapList(floor, floorKey);
                                                })
                                        }
                                    </Grid2>)}
                                <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                                    {((location_data?.action_type == 'edit' && !location_data?.selectedFloorKey && !location_data?.editNewFloorUpdated) || !(Object.keys(location_data?.floors).length > 0)) &&
                                        <div style={{ fontSize: 13, color: '#888', marginBottom: 8 }}>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ccc', margin: '16px 0' }} />
                                            <div style={{ fontWeight: 600, fontSize: 16, color: '#333', textAlign: 'left', marginBottom: 8, fontFamily: 'VerizonNHGDSBold' }}>
                                                Add new floor
                                            </div>
                                        </div>}
                                    {<div
                                        style={{
                                            border: '1px dashed #000000',
                                            borderRadius: '12px',
                                            padding: '32px 24px',
                                            textAlign: 'center',
                                            background: '#ffffffff',
                                            width: `100%`,
                                            display: `${(!location_data?.selectedFloorKey && !location_data?.editNewFloorUpdated) || !(Object.keys(location_data?.floors).length > 0) ? 'block' : 'none'}`,
                                        }}

                                        className='font20Location'
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <div className='font20Location' style={{
                                            borderRadius: "100px",
                                            width: "7%",
                                            padding: "7px",
                                            backgroundColor: "#ececec",
                                            display: "inline-block",
                                        }}>
                                            <Icon name="upload" size={"medium"} />
                                        </div> &nbsp;&nbsp;
                                        <span className='font20Location'>
                                            Drag file to upload
                                        </span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;or&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Button
                                            type="default"
                                            shape="round"
                                            className='font16Location'
                                            style={{ borderRadius: '24px', fontWeight: 'bold', marginBottom: 8, backgroundColor: 'white', color: 'black' }}
                                            onClick={() => document.getElementById('floor-map-upload-input').click()}
                                        >
                                            Browse
                                        </Button>
                                        <input
                                            id="floor-map-upload-input"
                                            type="file"
                                            accept=".jpg,.jpeg,.png"
                                            style={{ display: 'none' }}
                                            onChange={e => {
                                                handleBrowse(e);
                                            }}
                                        />
                                        <div className='font14Location' style={{ marginTop: 16 }}>
                                            Supported file types: JPG, PNG. Max file size: 10 MB
                                        </div>
                                        <div className='font14Location'>
                                            Note: All floor plans will be converted to black and white upon upload.
                                        </div>

                                    </div>}
                                    {
                                        (!(Object.keys(location_data?.floors).length > 0) || (errors?.['no_new_floors_added']?.length > 0)) && <ErrorMessage className={"ats-error-message-imp margin-8"} fieldName="noFloors" errors={{ 'noFloors': 'Please add at least one floor' }} />
                                    }

                                    {
                                        location_data?.action_type == 'edit' && location_data?.selectedFloorKey &&
                                        <>
                                            <div
                                                style={{
                                                    border: '1px dashed black',
                                                    borderRadius: '12px',
                                                    padding: '32px 24px',
                                                    textAlign: 'center',
                                                    background: '#ffffffff',
                                                    width: '100%',
                                                }}
                                            >
                                                <Button
                                                    type="default"
                                                    shape="round"
                                                    style={{
                                                        borderRadius: '24px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: 'black',
                                                        color: 'white'
                                                    }}
                                                    className='font12Location'
                                                    onClick={() => {
                                                        const { [location_data?.selectedFloorKey]: _, ...remainingNewZones } = location_data?.newZones;
                                                        dispatch(setLocationData({ ...location_data, addNewZoneButtonClicked: true, newZones: remainingNewZones }));
                                                        dispatch(updateModal({ current_modal: 'AddZone' }));
                                                    }}
                                                >
                                                    Add new zone
                                                </Button>
                                                <input
                                                    id="floor-map-upload-input"
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    style={{ display: 'none' }}
                                                    onChange={handleBrowse}
                                                />
                                                <div style={{ color: 'black', marginTop: 12 }} className='font11Location'>
                                                    click to add new zone to this floor
                                                </div>
                                            </div>
                                        </>
                                    }
                                </Grid2>
                            </Grid2>
                        </div>
                }
            </Spin>
        </Modal>
    </div>
);
};

export default LocationOptPopup;